import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';
import { useTheme } from '../context/ThemeContext';

const ContactModal = ({ isOpen, onClose, socialLinks = [] }) => {
  const { isDark } = useTheme();

  // Menutup modal dengan menekan tombol ESC pada keyboard
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          key="modal-backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/75 backdrop-blur-xs flex items-center justify-center z-50 p-4"
          onClick={onClose}
        >
          <motion.div
            key="modal-content"
            initial={{ scale: 0.85, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.85, opacity: 0, y: 20 }}
            transition={{ type: "spring", damping: 22, stiffness: 320 }}
            className={`pixel-border p-5 md:p-6 max-w-md w-full relative ${
              isDark ? 'bg-[#0D1520] text-slate-100' : 'bg-white text-gray-800'
            }`}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header Modal (Judul + Tombol Close Terpisah Cukup Jarak) */}
            <div className="flex items-center justify-between pb-4 mb-5 border-b-2 border-[var(--border-color)]">
              <div className="flex items-center gap-2">
                {/* <span className="w-2.5 h-2.5 bg-blue-600 inline-block"></span> */}
                <h3 className="text-sm md:text-base font-bold pixel-font tracking-wide">
                  MEDIA SOSIAL
                </h3>
              </div>

              <motion.button
                className={`p-1.5 border-2 border-transparent hover:border-[var(--border-color)] transition-colors focus:outline-none ${
                  isDark ? 'text-slate-400 hover:text-slate-100' : 'text-gray-500 hover:text-gray-900'
                }`}
                onClick={onClose}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                aria-label="Tutup modal media sosial"
              >
                <FaTimes className="text-lg md:text-xl" />
              </motion.button>
            </div>

            {/* Social Links Grid */}
            <div className="grid grid-cols-2 gap-3 md:gap-4 max-h-[70vh] overflow-y-auto pr-1">
              {socialLinks.map((social, index) => {
                // Item ke-7 (ganjil) dibuat membentang 2 kolom agar grid seimbang
                const isLastOdd = index === socialLinks.length - 1 && socialLinks.length % 2 !== 0;

                return (
                  <motion.a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    initial={{ opacity: 0, y: 15 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.05 }}
                    whileHover={{ scale: 1.03, y: -3 }}
                    whileTap={{ scale: 0.96 }}
                    className={`${social.color} ${
                      isLastOdd ? 'col-span-2 sm:col-span-1' : 'col-span-1'
                    } text-white pixel-button p-3.5 md:p-4 flex flex-col items-center justify-center text-center transition-all group`}
                  >
                    <div className="text-2xl md:text-3xl group-hover:scale-110 transition-transform duration-200">
                      {social.icon}
                    </div>
                    <span className="mt-2 text-xs md:text-sm font-medium tracking-wide">
                      {social.name}
                    </span>
                  </motion.a>
                );
              })}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ContactModal;